import {
  ForkKnifeIcon,
  CoffeeIcon,
  MartiniIcon,
  BeerSteinIcon,
  CookieIcon,
  ShoppingCartIcon,
  StorefrontIcon,
  BasketIcon,
  BedIcon,
  BarbellIcon,
  FilmSlateIcon,
  BankIcon,
  PillIcon,
  MapPinIcon as DefaultIcon,
  type Icon,
  type IconWeight,
} from "@phosphor-icons/react";

// Business-type slug -> glyph. Slugs match the canonical business_type values.
const GLYPHS: Record<string, Icon> = {
  restaurant: ForkKnifeIcon,
  cafe: CoffeeIcon,
  bar: MartiniIcon,
  pub: BeerSteinIcon,
  bakery: CookieIcon,
  supermarket: ShoppingCartIcon,
  food: ShoppingCartIcon,
  store: StorefrontIcon,
  shop: StorefrontIcon,
  grocery: BasketIcon,
  hotel: BedIcon,
  lodging: BedIcon,
  gym: BarbellIcon,
  cinema: FilmSlateIcon,
  bank: BankIcon,
  pharmacy: PillIcon,
};

function lookupGlyph(businessType?: string | null): { Glyph: Icon; isDefault: boolean } {
  const key = (businessType || "").trim().toLowerCase();
  const match = GLYPHS[key];
  return { Glyph: match ?? DefaultIcon, isDefault: !match };
}

export function glyphForBusinessType(businessType?: string | null): Icon {
  return lookupGlyph(businessType).Glyph;
}

interface BusinessTypeGlyphProps {
  businessType?: string | null;
  size: number;
  /** Overridden only where the pin face changes colour under the glyph. */
  color?: string;
  weight?: IconWeight;
}

/** Render the business-type glyph (used on map pins). */
export function BusinessTypeGlyph({
  businessType,
  size,
  color = "var(--foreground-neutral-strong)",
  weight = "fill",
}: BusinessTypeGlyphProps) {
  const { Glyph, isDefault } = lookupGlyph(businessType);
  // Outline, not filled: the autosuggest/pin data often lacks a resolved
  // business type before the venue is actually opened, so this fallback also
  // fires for supported categories we just don't know yet — it must read as
  // "unknown", not assert "unsupported".
  return <Glyph size={size} color={color} weight={isDefault ? "regular" : weight} />;
}
